import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const ifcClustersRoutes: Routes = [
    {
        path: 'ifc-clusters/profiles',
        loadComponent: () =>
            import('../ifc-clusters/ifc-cluster-profiles/ifc-cluster-profiles.component').then(
                (m) => m.IfcClusterProfilesComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'ifc-clusters/profiles/:id',
        loadComponent: () =>
            import('../ifc-clusters/ifc-cluster-profile-detail/ifc-cluster-profile-detail.component').then(
                (m) => m.IfcClusterProfileDetailComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'ifc-clusters/profiles/:id/members/:memberId/livelihood-profile',
        loadComponent: () =>
            import('../ifc-clusters/ifc-member-livelihood-profile/ifc-member-livelihood-profile.component').then(
                (m) => m.IfcMemberLivelihoodProfileComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'ifc-clusters/profiles/:id/members/:memberId',
        loadComponent: () =>
            import('../ifc-clusters/ifc-member-detail/ifc-member-detail.component').then(
                (m) => m.IfcMemberDetailComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'ifc-clusters/lsc',
        loadComponent: () =>
            import('../ifc-clusters/ifc-lsc-list/ifc-lsc-list.component').then((m) => m.IfcLscListComponent),
        canActivate: [authGuard]
    },
    {
        path: 'ifc-clusters/activity',
        loadComponent: () =>
            import('../ifc-clusters/ifc-cluster-activity/ifc-cluster-activity.component').then(
                (m) => m.IfcClusterActivityComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'ifc-clusters/activity/:id/sessions/:sessionId',
        loadComponent: () =>
            import('../ifc-clusters/ifc-cluster-activity-detail/ifc-cluster-activity-detail.component').then(
                (m) => m.IfcClusterActivityDetailComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'ifc-clusters/activity/:id',
        loadComponent: () =>
            import('../ifc-clusters/ifc-cluster-activity-sessions/ifc-cluster-activity-sessions.component').then(
                (m) => m.IfcClusterActivitySessionsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'ifc-clusters/services',
        loadComponent: () =>
            import('../ifc-clusters/ifc-cluster-services/ifc-cluster-services.component').then(
                (m) => m.IfcClusterServicesComponent
            ),
        canActivate: [authGuard]
    }
];

export const ifcClustersMobileRoutes: Routes = [
    {
        path: 'mobile/ifc-cluster/ifc-home',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-home/ifc-home.component').then((m) => m.IfcHomeComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-profile',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-profile/ifc-profile.component').then(
                (m) => m.IfcProfileComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-activity',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-activity/ifc-activity.component').then(
                (m) => m.IfcActivityComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-activity/view-info/:id',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/activity-view-info/activity-view-info.component').then(
                (m) => m.ActivityViewInfoComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-activity/add',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/add-activity/add-activity.component').then(
                (m) => m.AddActivityComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-activity/view-activity/:id',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/view-activity/view-activity.component').then(
                (m) => m.ViewActivityComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-lsc',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-lsc/ifc-lsc.component').then((m) => m.IfcLscComponent),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-lsc/add',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-lsc-add/ifc-lsc-add.component').then(
                (m) => m.IfcLscAddComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-lsc/:id/items/filter',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-lsc-item-filter/ifc-lsc-item-filter.component').then(
                (m) => m.IfcLscItemFilterComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-lsc/:id/items/add',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-lsc-item-form/ifc-lsc-item-form.component').then(
                (m) => m.IfcLscItemFormComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-lsc/:id/items/update',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-lsc-inventory-update/ifc-lsc-inventory-update.component').then(
                (m) => m.IfcLscInventoryUpdateComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-lsc/inventory/:id',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-lsc-inventory/ifc-lsc-inventory.component').then(
                (m) => m.IfcLscInventoryComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-lsc/:id/items',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-lsc-item-list/ifc-lsc-item-list.component').then(
                (m) => m.IfcLscItemListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-lsc/:id',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-lsc-detail/ifc-lsc-detail.component').then(
                (m) => m.IfcLscDetailComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/view-activity',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/view-activity/view-activity.component').then(
                (m) => m.ViewActivityComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-cluster-pages/add-new-service',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/add-new-service/add-new-service.component').then(
                (m) => m.AddNewServiceComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-profile/filter',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-filter/ifc-filter.component').then(
                (m) => m.IfcFilterComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-profile/:id',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-profile-details/ifc-profile-details.component').then(
                (m) => m.IfcProfileDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-profile/:id/summary',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-summary/ifc-summary.component').then(
                (m) => m.IfcSummaryComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-profile/:id/members',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-member-list/ifc-member-list.component').then(
                (m) => m.IfcMemberListComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/ifc-profile/:id/members/add',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-member-form/ifc-member-form.component').then(
                (m) => m.IfcMemberFormComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'mobile/ifc-cluster/basic-info',
        pathMatch: 'full',
        redirectTo: 'mobile/ifc-cluster/ifc/add'
    },
    {
        path: 'mobile/ifc-cluster/ifc/add',
        loadComponent: () =>
            import('../mobile/pages/ifc-cluster-pages/ifc-registration/ifc-registration.component').then(
                (m) => m.IfcRegistrationComponent
            ),
        canActivate: [authGuard]
    }
];
